import React, { useRef, useState } from 'react'
import Footer from '../../components/Footer'
import TechnologyTab from '../../components/TechnologyTab'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Navbar from '../../components/Navbar'
import { PrimaryButton, PrimaryButton2th } from '../../components/StyledButtons'
import { useTranslation } from 'react-i18next'
import playVideoIcon from '../../assets/images/icons/playvideo-button.svg';
import { Dialog, DialogActions, DialogContent, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
import ReactPlayer from 'react-player'
import generating from "../../assets/images/contents/generating-video.png"
import generation_1 from "../../assets/images/contents/pdf-generation-1.png"
import generation_2 from "../../assets/images/contents/pdf-generation-2.png"
import generation_3 from "../../assets/images/contents/pdf-generation-3.png"
import generation_4 from "../../assets/images/contents/pdf-generation-4.png"
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const PDFGeneration = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const [openVideo, setOpenVideo] = useState(false);

  const handleOpenVideo = () => {
    setOpenVideo(true);
  }

  const handleCloseVideo = () => {
    setOpenVideo(false);
  };

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

  const CustomPopupVideo = (props) => {
    return (
      <div>
        <Dialog open={props.open} onClose={props.handleClose} on>
          <DialogActions>
            <IconButton onClick={props.handleClose} >
              <Close />
            </IconButton>
          </DialogActions>
          <DialogContent className='video-popup'>
            <ReactPlayer
              url={props.url}
              controls={true}
              style={{ maxWidth: '100%' }}
              playing={true}
            />
          </DialogContent>

        </Dialog>
      </div>
    )
  }


  return (
    <div className='pdf-generation bg-primary'>
      <div className='color-filter-right' style={{ top: "45%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "60%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
      <Navbar />
      <div className='container-fluid integration-header'>
        <div className='container pt-50 pt-md-150'>
          <div className='col-md-7 col-sm-12 px-md-0 pt-lg-100 pt-50'>
            {language === "en"
              ?
              <p className='font-64 font-weight-semi-bold header-title'>
                Simple and Easy PDF Document Generation - with Qrypto
              </p>
              :
              <p className='font-64 font-weight-semi-bold header-title pr-xl-100'>
                Tạo tài liệu PDF đơn giản và dễ dàng - với Qrypto
              </p>
            }
          </div>
          <div className='col-md-5 col-sm-12'>
            <img src={generation_1} alt="overview_1" className='img-responsive' width="450" />
          </div>
        </div>
      </div>
      <TechnologyTab pdfGenerationActive={true} />
      <div className='container'>
        <div className='flex justify-center'>
          <div className='technology-chip'>
            <p className='text-center header-title font-40 uppercase'>{t('technology-tab.pdf-generation')}</p>
          </div>
        </div>
        <div className='col-md-8 col-md-offset-2 pt-30'>
          <p className='text-white text-center'>
            {t('pdf-generation.sub-title-a')}
          </p>
          <p className='text-white text-center'>
            {t('pdf-generation.sub-title-b')}
          </p>
        </div>
      </div>
      <div className='container pt-50'>
        <div className="generating-documents col-sm-12">
          <div className="col-lg-6">
            <p className="font-weight-semi-bold font-32 text-white">{t('pdf-generation.title-1')}</p>
            <p className="text-white pt-30">{t('pdf-generation.sub-title-1')}</p>
            <p className='pt-20 text-white'>{t('pdf-generation.content-1-1')}</p>
            <p className='pt-20 text-white'>{t('pdf-generation.content-1-2')}</p>
            <ul className='list-unstyled pt-10'>
              <li className="checked-line font-weight-semi-bold">{t('pdf-generation.content-1-3')}</li>
              <li className="checked-line font-weight-semi-bold">{t('pdf-generation.content-1-4')}</li>
            </ul>
          </div>
          <div className="col-lg-6">
            <img src={generation_2} alt="generation_2" className='img-responsive pt-40' />
          </div>
        </div>
      </div>

      <div className='container pt-50'>
        <div className="generating-programmatically col-sm-12">
          <div className='col-lg-6 pt-10'>
            <img src={generation_3} alt="generation_3" className='img-responsive' />
          </div>
          <div className='col-lg-6 pt-md-0 pt-20'>
            <p className='font-32 font-weight-semi-bold'>{t('pdf-generation.title-2')}</p>
            <p className='pt-20'>{t('pdf-generation.sub-title-2')}</p>
            {language === "en"
            ?
            <ul className='list-unstyled pt-10'>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Setup a workflow template</span> using MS Word/Libre Writer indicating where the variable data will be filled up. Optionally setup a background PDF/watermark.</li>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Call the API</span> with your variable data in JSON format along with the workflow id and API authentication token. It returns a link to download the finished PDF!</li>
            </ul>
            :
            <ul className='list-unstyled'>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Thiết lập mẫu quy trình công việc</span> sử dụng MS Word/Libre Writer cho biết nơi dữ liệu biến đổi sẽ được điền vào. Tùy chọn thiết lập PDF/hình mờ nền.</li>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Gọi API</span> với dữ liệu biến của bạn ở định dạng JSON cùng với id luồng công việc và mã thông báo xác thực API. Nó trả về một liên kết để tải xuống bản PDF đã hoàn thành!</li>
            </ul>
            }
          </div>
        </div>
      </div>

      <div className='container pt-50'>
        <div className="easy col-sm-12">

          <div className='col-lg-6 pt-lg-40'>
            <p className='font-32 font-weight-semi-bold text-white'>{t('pdf-generation.title-3')}</p>
            <p className='pt-30 text-white'>{t('pdf-generation.sub-title-3')}</p>
            <p className='pt-20 pb-30 text-white'>{t('pdf-generation.content-3')}</p>
            <PrimaryButton className='mb-20'
            onClick={() => setModalDiscussionOpen(true)}
            >{t('button.schedule-discussion')}</PrimaryButton>
          </div>
          <div className='col-lg-6'>
            <div className='relative'>
              <IconButton className='img-center-button' disableRipple style={{ padding: 0 }} onClick={handleOpenVideo}>
                <img src={playVideoIcon} alt="" className='icon-60' />
              </IconButton>
              <img src={generating} alt="generating" className='img-responsive' />
              <CustomPopupVideo open={openVideo} handleClose={handleCloseVideo} url="https://s3-ap-southeast-1.amazonaws.com/qdev/00sft/www/QWA-Qryptal-PDF-Generation.m4v" />
            </div>
          </div>
        </div>
      </div>

      <div className='container pt-50'>
        <div className="ad-hoc col-sm-12">
          <div className='col-lg-6'>
            <img src={generation_4} alt="generation_4" className='img-responsive' />
          </div>
          <div className='col-lg-6'>
            <p className='font-weight-semi-bold font-32'>{t('pdf-generation.title-4')}</p>
            <p className='pt-20'>{t('pdf-generation.sub-title-4')}</p>
            {language === "en"
            ?
            <ul className='list-unstyled pt-10'>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Setup a workflow template</span> using MS Word/Libre Writer indicating where the variable data will be filled up.</li>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Optionally</span> setup a background PDF/watermark. Along with it, set up a Form to enter the variable data.</li>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Fill up the details</span> on the form and click on the Generate button. The finished PDF is presented for download. That’s it!</li>
            </ul>
            :
            <ul className='list-unstyled'>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Thiết lập mẫu quy trình công việc</span> sử dụng MS Word/Libre Writer cho biết nơi dữ liệu biến đổi sẽ được điền vào.</li>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Tùy chọn</span> thiết lập một hình nền PDF/hình mờ. Cùng với đó là thiết lập Form để nhập dữ liệu biến.</li>
              <li className="checked-line-secondary"><span className="font-weight-semi-bold">Điền thông tin chi tiết</span> trên biểu mẫu và nhấp vào nút Tạo. Bản PDF hoàn chỉnh được trình bày để tải xuống. Đó là nó!</li>
            </ul>
            }
          </div>
          <div className='col-sm-12 pt-30'>
            <p>{t('pdf-generation.content-4-1')}</p>
            <p className='pt-20'>{t('pdf-generation.content-4-2')}</p>
            <p className='pt-20'>{t('pdf-generation.content-4-3')}</p>
            <p className='pt-20'>{t('pdf-generation.content-4-4')}</p>
            <p className='pt-20 pb-20'>{t('pdf-generation.content-4-5')}</p>
            <PrimaryButton2th
            onClick={() => setModalDiscussionOpen(true)}
            >{t('button.schedule-discussion')}</PrimaryButton2th>
          </div>
        </div>
      </div>

      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
      {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
    </div>
  )
}

export default PDFGeneration